import { useState, useCallback, useEffect } from 'react'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ButtonSecondary } from '../../../../../Button'
import { ModalBigCentered } from '../../../../../Modal'
import TwinTrans from '../../../../../TwinTrans'
import FormRenderer from '../../../../../../forms/FormRenderer'
import { FormSection } from '../../../../../../forms/FormRenderer/types'
import './modalSeeMoreSections.sass'

interface InputTableSeeMoreSectionsComponentProps {
    fields: FormSection<any>[]
    getCompleteData: () => void
 }

const InputTableSeeMoreSectionsComponent: React.FC<InputTableSeeMoreSectionsComponentProps> = ({ fields, getCompleteData }) => {
    const { opened, setOpened } = useInputTableSeeMoreSectionsComponentLogic()
    return (
        <div className='flex items-center see_more_data_icon'>
            <ButtonSecondary className='regular14 whitespace-nowrap' onClick={() => setOpened((old) => !old)}><TwinTrans transKey={'seeMore'}>Ver más</TwinTrans></ButtonSecondary>
            {opened ? <ModalSeeMoreSections {...{ setOpened, fields, getCompleteData }} /> : null}
        </div>
    )
}

const useInputTableSeeMoreSectionsComponentLogic = () => {
    const [opened, setOpened] = useState<boolean>(false)

    return { opened, setOpened }
}


interface ModalSeeMoreSectionsProps extends ModalSeeMoreSectionsLogicProps {
    fields: FormSection<any>[]
}

const ModalSeeMoreSections: React.FC<ModalSeeMoreSectionsProps> = ({ setOpened, fields, getCompleteData }) => {
    const { t } = useTwinTranslation()
    const { myOnSubmit, lockOnClickOut, setLockOnClickOut } = useModalSeeMoreSectionsLogic({ getCompleteData, setOpened })
    return (
        <ModalBigCentered opened={true} setOpened={() => setOpened(false)} className='flex modal_see_more_order_header overflow-auto' onClickOut={!lockOnClickOut}>
            <div className='flex flex-col gap-20 modal_see_more_order_header_container'>
                <h2 className='w-full mb-10'>{t('allDataM', 'Todos los datos')}</h2>
                <div className='modal_negative_margin flex-auto flex-col mb-20 flex'>
                    <FormRenderer sections={fields} className='see_more_sections_form flex-auto overflow-auto  pr-30' allExtraDataComponentProps={{setLockOnClickOut}} />
                </div>
                <ButtonSecondary onClick={myOnSubmit} className='w-100 ml-auto mt-10 regular14'>
                    <TwinTrans transKey='accept'>Aceptar</TwinTrans>
                </ButtonSecondary>
            </div>
        </ModalBigCentered>
    )
}

interface ModalSeeMoreSectionsLogicProps {
    getCompleteData: () => void
    setOpened: (value: React.SetStateAction<boolean>) => void
}

const useModalSeeMoreSectionsLogic = ({ getCompleteData, setOpened }: ModalSeeMoreSectionsLogicProps) => {
    const [lockOnClickOut, setLockOnClickOut] = useState(false)
    const myOnSubmit = useCallback(() => {
        getCompleteData()
        setOpened(false)
    }, [getCompleteData, setOpened])

    useEffect(() => {
        getCompleteData()
    }, [getCompleteData])

    return { myOnSubmit, lockOnClickOut, setLockOnClickOut }
}

export default InputTableSeeMoreSectionsComponent